import { render, staticRenderFns } from "./CustomPageIcon.vue?vue&type=template&id=893c400a&scoped=true&"
import script from "./CustomPageIcon.vue?vue&type=script&lang=js&"
export * from "./CustomPageIcon.vue?vue&type=script&lang=js&"
import style0 from "./CustomPageIcon.vue?vue&type=style&index=0&id=893c400a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893c400a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
